import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../widgets/IconButton';
import ActionDelete from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ViewIcon from '@material-ui/icons/Pageview';
import PersistedDataTable from '../widgets/persistedDataTable';

const ProgressClaimCommentTemplatesGrid = ({ 
	commentTemplates, canEdit, canView, onEditProgressClaimCommentTemplate, onDeleteProgressClaimCommentTemplate, onViewProgressClaimCommentTemplate
}) => {
	const columns = [
		{ name: 'name', label: 'Name' },
		{ name: 'comment', label: 'Comment' },
		{ name: 'isActive', label: 'Is Active', dataType: 'bool' }
	];

	if (canEdit) {
		columns.splice(0, 0, {
			name: 'commands',
			excludeFromSearch: true,
			excludeFromFilter: true,
			cellRenderer: (args) => 
				<div style={{ whiteSpace: 'nowrap' }}>
					<IconButton onClick={ () => { onEditProgressClaimCommentTemplate(args.data); } } style={{ padding: '2px' }}>
						<EditIcon />
					</IconButton>
					<IconButton onClick={ () => { onDeleteProgressClaimCommentTemplate(args.data); } } style={{ padding: '2px' }}>
						<ActionDelete />
					</IconButton>
				</div>
		});
	} else if (canView) {	
		columns.splice(0, 0, {
			name: 'commands',
			excludeFromSearch: true,
			excludeFromFilter: true,
			cellRenderer: (args) => 
				<div style={{ whiteSpace: 'nowrap' }}>
					<IconButton onClick={ () => { onViewProgressClaimCommentTemplate(args.data); } } style={{ padding: '2px' }}>
						<ViewIcon />
					</IconButton>
				</div>
		});
	}

	return (
		<PersistedDataTable 
			id="commentTemplates"
			data={commentTemplates || []} 
			columns={columns}
		/>
	);
};

ProgressClaimCommentTemplatesGrid.propTypes = {
	commentTemplates: PropTypes.array.isRequired,
	canView: PropTypes.bool.isRequired,
	canEdit: PropTypes.bool.isRequired,
	onEditProgressClaimCommentTemplate: PropTypes.func.isRequired,
	onViewProgressClaimCommentTemplate: PropTypes.func.isRequired,
	onDeleteProgressClaimCommentTemplate: PropTypes.func.isRequired
};

export default ProgressClaimCommentTemplatesGrid;
